const isLocal = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
const API_URL = isLocal ? "http://127.0.0.1:5000" : "https://gt2.insight.appserve.io/api";

module.exports = { API_URL };
